import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const birthdayFeatures = [
  'Professional pin setters',
  'Food & beverage options',
  'Private party rooms',
  'Arcade games included',
  'Photo opportunities',
  'Custom party themes',
];

const corporateFeatures = [
  'Team building activities',
  'Customizable packages',
  'Full catering available',
  'Dedicated event coordinator',
  'Flexible scheduling',
  'Private lane reservations',
];

const socialFeatures = [
  'Rock & Roll bowling nights',
  'Group discounts available',
  'Glow bowling experience',
  'Music & light shows',
  'Full bar & snack menu',
  'Weekend specials',
];

const fundraiserFeatures = [
  'Customized event planning',
  'Percentage of sales donated',
  'Marketing support',
  'Private or shared lanes',
  'Food packages available',
  'Fun for all ages',
];

function PartiesEvents() {
  return (
    <div className="parties-page">
      <Helmet>
        <title>Parties & Events — SkyLanes Bowling Center</title>
        <meta name="description" content="Host your next party or corporate event at SkyLanes Bowling Center. Birthday parties, corporate team building, social events, and fundraisers in East Stroudsburg, PA." />
        <meta property="og:title" content="Parties & Events — SkyLanes Bowling Center" />
        <meta property="og:description" content="Host your next party or corporate event at SkyLanes Bowling Center in the Poconos." />
        <link rel="canonical" href="https://skylanesbowling.com/parties-events" />
      </Helmet>
      {/* Hero */}
      <section className="parties-hero" style={{
        background: `linear-gradient(180deg, transparent 0%, #240A2B 100%), url(${process.env.PUBLIC_URL}/images/parties-hero.jpg) center/cover no-repeat`
      }}>
        <div className="container">
          <Link to="/" className="back-link">&larr; Back to Home</Link>
          <h1>Parties & Events</h1>
          <p>
            From birthday celebrations to corporate team building, SkyLanes Bowling Center
            is the perfect venue for your next event. Let us make your occasion unforgettable!
          </p>
          <a href="tel:+15704217680" className="btn">Call to Book</a>
        </div>
      </section>

      {/* Main Services - 3 Column */}
      <section className="parties-services section-padding">
        <div className="container">
          <div className="parties-services-grid">
            <div className="party-service-card">
              <div className="party-icon">🎂</div>
              <h3>Birthday Parties</h3>
              <p>
                Celebrate your special day with a bowling party the whole family will love!
                We offer packages for all ages with food, drinks, and arcade fun included.
              </p>
              <ul className="party-features">
                {birthdayFeatures.map((f, i) => (
                  <li key={i}><span className="check-red">✓</span> {f}</li>
                ))}
              </ul>
              <a href="tel:+15704217680" className="btn">Call Us Now</a>
            </div>

            <div className="party-service-card featured">
              <div className="featured-image">
                <img
                  src="/images/kids.jpeg"
                  alt="Kids bowling birthday party at SkyLanes Bowling Center"
                  loading="lazy"
                />
              </div>
              <div className="featured-text">
                <h3>Make Every Event Special</h3>
                <p>
                  Whether it's a small gathering or a large celebration, our dedicated team will
                  ensure everything runs smoothly. Contact us to customize your perfect event package.
                </p>
                <div className="featured-social">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">f</a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">ig</a>
                </div>
              </div>
            </div>

            <div className="party-service-card">
              <div className="party-icon">💼</div>
              <h3>Corporate Events</h3>
              <p>
                Boost team morale with an exciting corporate bowling event. We handle everything
                from catering to lane setup so you can focus on having fun.
              </p>
              <ul className="party-features">
                {corporateFeatures.map((f, i) => (
                  <li key={i}><span className="check-red">✓</span> {f}</li>
                ))}
              </ul>
              <a href="tel:+15704217680" className="btn">Call Us Now</a>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="parties-additional section-padding">
        <div className="container">
          <div className="additional-header">
            <h5>More Options</h5>
            <h2>Additional Event Types</h2>
          </div>
          <div className="additional-grid">
            <div className="additional-card">
              <div className="additional-icon">🎉</div>
              <h3>Social Events</h3>
              <p>
                Get your friends together for an unforgettable night out! Our social event packages
                include glow bowling, music, and great food.
              </p>
              <ul className="party-features">
                {socialFeatures.map((f, i) => (
                  <li key={i}><span className="check-red">✓</span> {f}</li>
                ))}
              </ul>
              <a href="tel:+15704217680" className="btn">Call Us</a>
            </div>

            <div className="additional-card">
              <div className="additional-icon">❤️</div>
              <h3>Fundraisers</h3>
              <p>
                Host a bowling fundraiser at SkyLanes! We'll help you plan the perfect event
                to support your cause while everyone has a great time.
              </p>
              <ul className="party-features">
                {fundraiserFeatures.map((f, i) => (
                  <li key={i}><span className="check-red">✓</span> {f}</li>
                ))}
              </ul>
              <a href="tel:+15704217680" className="btn">Call Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="parties-cta">
        <div className="container">
          <h2>Ready to Plan Your Event?</h2>
          <p>Call us today and let our event team help you create the perfect experience.</p>
          <a href="tel:+15704217680" className="btn">Call (570) 421-7680</a>
        </div>
      </section>
    </div>
  );
}

export default PartiesEvents;
